import { useWindowSize } from 'usehooks-ts';
import { useStyles } from './useStyles';

export function useBreakpoints() {
  const { theme } = useStyles();
  const windowSize = useWindowSize();
  const isExtraSmall = windowSize.width <= theme.breakpoints.extraSmall;
  const isSmall = windowSize.width <= theme.breakpoints.small;
  const isMedium = windowSize.width <= theme.breakpoints.medium;
  const isLarge = windowSize.width <= theme.breakpoints.large;
  const isExtraLarge = windowSize.width <= theme.breakpoints.extraLarge;

  return {
    isExtraSmall,
    isSmall,
    isMedium,
    isLarge,
    isExtraLarge,
  };
}
